var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('Foot')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containers"},[_c('img',{attrs:{"src":require("../assets/developing.png"),"alt":""}}),_c('p',[_vm._v("页面正在建设中...")])])
}]

export { render, staticRenderFns }